import styled from 'styled-components'
import { typoHeading6 } from '../../lib/styles/Typography'
import { Heading } from '../../types'
import { RecommendedArticleAssetComponentProps } from './types'
import { baseTransition } from '../../lib/styles/Style'

export const StyledRecommendArticlesContainer = styled.div<RecommendedArticleAssetComponentProps>`
  display: flex;
  flex-direction: column;
  margin-top: 4rem;
  gap: ${({ $isSmall }) => ($isSmall ? '0.5rem' : '1rem')};
  &:has(+ .recommended-articles) {
    margin-bottom: -1rem;
  }
  * {
    transition-property: all;
    ${baseTransition};
  }
`

export const StyledRecommendArticlesHeadline = styled.div<{ readonly as?: Heading }>`
  &.recommended-articles-headline {
    ${typoHeading6};
    margin-bottom: 1rem;
  }
`
